import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { useStore } from '@hmpu/powerups.store';
import { useEffect } from 'react';

export type GameControlsPanelProps = {};

export function GameControls() {
  const { __t } = useTranslation('SETTINGS_PANEL');
  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const inPortrait = useStore((state) => state.inPortrait);

  useEffect(() => {
    setPageTitle(
      __t('gameControls', 'SETTINGS_PANEL') +
        ' | ' +
        __t('pageTitle', 'SETTINGS_PANEL').split('|')[1]
    );
  }, [showSettingsPanel, isPauseEnabled, inPortrait]);

  useEffect(() => {
    const backButton = document.querySelector("#SettingsPanel-Back") as HTMLElement | null;
    if (backButton) {
      backButton.focus();
    }   
  }, [showSettingsPanel, inPortrait, isPauseEnabled]);
  return (
    <section className="SettingsPanel-Container">
      <h1 tabIndex={0}>{__t('gameControls')}</h1>
      <p tabIndex={0}>{__t('gameControlsBody1')}</p>
      <p tabIndex={0}>{__t('gameControlsBody2')}</p>
      {/* <p tabIndex={0}>{__t('gameControlsBody3')}</p> */}
      {/* <div className='a11y-controls-list'>
        <p>&#8226; &nbsp; {__t('gameControlsBody4_1')}</p>
        <p>&#8226; &nbsp; {__t('gameControlsBody4_2')}</p>
        <p>&#8226; &nbsp; {__t('gameControlsBody4_3')}</p>
        <p>&#8226; &nbsp; {__t('gameControlsBody4_4')}</p>
      </div> */}
    </section>
  );
}
